<template>
  <div class="page">
    <Header @changeLang="changeLang" @getConfig="getConfig" :applicationLocale="applicationLocale"></Header>
    <div class="container">
      <div class="column">
        <div class="left">
          <el-carousel 
            v-if="headlineList.length > 0"
            class="swiper-box" 
            :interval="4000" 
            height="432px"
            
            :initial-index="currentIndex"
            @change="change"
          >
            <el-carousel-item v-for="(item, index) in headlineList" :key="index">
              <div class="carousel-item">
                <div class="text">{{ applicationLocale === 'en' ? item.title_en : item.title }}</div>
                <img :src="item.image_url" style="width: 100%; height: 100%; cursor: pointer; object-fit: cover;" @click="article(item.id)" />
                <i class="el-icon-arrow-left move" style="left: 10px;" @click="prev"></i>
                <i class="el-icon-arrow-right move" style="right: 10px;" @click="next"></i>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div v-else class="swiper-box" style="display: flex; align-items: center; justify-content: center; background: #f0f0f0;">
            <span>加载中...</span>
          </div>
        </div>
        <div class="right" style="max-height: 400px;">
          <img 
            v-for="(item, index) in adList" 
            :key="index" 
            :src="item.image_url" 
            v-if="item.type === 1 && index === 0" 
            style="width: 100%;" 
            @click="nav(item.url)"
          />
        </div>
      </div>
      <div class="column-title">{{ $t('index.hot-match') }}</div>
      
      <div class="con" style="display: none;">
        <div v-for="(item, index) in adList" :key="index" v-if="item.type === 2" class="bet-news">
          <jyf-parser :html="item.url" />
        </div>
      </div>
      <div class="con hot-match">
        <div v-for="(item, index) in matchList" :key="index" v-if="index < 4" class="matchs" :class="'match-box-' + index" @click="nav(adList[0] && adList[0].url)">
          <div class="tournament">
            {{ item.tournament }}
          </div>
          <div class="match">
            <div class="team">
              <div><img :src="item.homeLogo" /></div>
              <div class="name">{{ item.homeName }}</div>
            </div>
            <div class="detail">
              <div class="time">{{ item.matchStageName === 'unstarted' ? formatTimestamp(item.matchTime) : item.matchStageName }}</div>
              <div class="odds">
                <div class="odds-value" v-if="item.homeOdds">{{ item.homeOdds }}</div>
                <div class="odds-value" v-if="item.drawOdds">{{ item.drawOdds }}</div>
                <div class="odds-value" v-if="item.awayOdds">{{ item.awayOdds }}</div>
              </div>
            </div>
            <div class="team">
              <div><img :src="item.awayLogo" /></div>
              <div class="name">{{ item.awayName }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="column">
        <div class="left">
          <div class="left-ad">
            <div class="ad-title">- Sponsored Ad -</div>
            <div class="ad-list">
              <img 
                v-for="(item, index) in adList" 
                :key="index" 
                :src="item.image_url" 
                v-if="item.type === 0" 
                @click="nav(item.url)" 
              />
            </div>
          </div>
          <div class="column-title">{{ $t('index.latest-news') }}</div>
          <Latest :item="newsList" :applicationLocale="applicationLocale"></Latest>
          <div style="text-align: center; cursor: pointer;  margin-top: 20px;" @click="nav('/pages/news/category?id=15')">更多新闻</div>
        </div>
        <Recommend :applicationLocale="applicationLocale" :config="config" :adList="adList" :headlineList="headlineList" page="index"></Recommend>
      </div>
    </div>
    <Footer @changeLang="changeLang" :applicationLocale="applicationLocale"></Footer>
    <!-- AD -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="100%"
      custom-class="popup-dialog"
    >
      <div class="card-detail booster-info dialogTop dialog" style="text-align: center; display: flex;justify-content: center; flex-direction: column;gap: 20px;">
        <img 
          v-for="(item, index) in adList" 
          :key="index" 
          :src="item.image_url" 
          v-if="item.type === 3" 
          style="width: 90%; max-width: 720px; margin: 0 auto;"
          @click="nav(item.url)"
          
        />
        <i class="el-icon-close" style="font-size: 48px; color: #fff; cursor: pointer;" @click="popup('close')"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/'
import Latest from '@components/latest/latest.vue'
import Header from '@components/header/header.vue'
import Footer from '@components/footer/footer.vue'
import Recommend from '@components/recommend/recommend.vue'
import jyfParser from '@components/jyf-parser/jyf-parser'
import storage from '@/utils/storage'
import i18nUtil from '@/utils/i18n'

export default {
  components: {
    Latest,
    Header,
    Footer,
    Recommend,
    jyfParser
  },
  data() {
    return {
      modeIndex: -1,
      styleIndex: -1,
      current: 0,
      mode: 'default',
      swiperDotIndex: 0,
      newsList: [],
      topHeight: '',
      currentIndex: 2,
      applicationLocale: i18nUtil.getLocale(),
      adList: storage.getItem('ad') || [],
      config: storage.getItem('config') || {},
      market: '',
      arr: [
        '1 不是被郭德纲发现的，也不是一开始就收为徒弟。',
        '2 现在雅阁这个状态像极了新A4L上市那段日子。',
        '3 低配太寒碜，各种需要加装，中配定价过高，又没啥特色',
        '4 然后各种机油门、经销商造反什么的幺蛾子。',
        '5 看五月销量，建议参考A4，打8折吧。',
        '1 不是被郭德纲发现的，也不是一开始就收为徒弟。'
      ],
      headlineList: [],
      popupAD: true,
      matchList: [],
      dialogVisible: false
    }
  },
  mounted() {
    this.getNewsList()
    if (!storage.getItem('ad')) this.getAd()
    this.getHeadlineList()
    this.popup('open')
    this.applicationLocale = i18nUtil.getLocale()
    this.getMarket()
    this.getMatch()
  },
  methods: {
    getMatch() {
      const lang = this.applicationLocale === 'en' ? 'en' : 'zh-cn'
      api.getData('index/hotMatch', { lang: lang })
        .then((res) => {
          this.matchList = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp)
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      return `${month}-${day} ${hour}:${minute}`
    },
    async getNewsList() {
      let data = {
        page: 1,
        limit: 20,
        homeNews: true
      }
      api.getData('index/articleList', data)
        .then((res) => {
          this.newsList = res.data.data.list
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getHeadlineList() {
      let data = {
        page: 1,
        limit: 8,
        headline: true
      }
      api.getData('index/articleList', data)
        .then((res) => {
          this.headlineList = res.data.data.list
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getMarket() {
      let data = {
        page: 1,
        limit: 20
      }
      api.getData('index/market', data)
        .then((res) => {
          this.market = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    change(index) {
      this.currentIndex = index
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.headlineList.length) % this.headlineList.length
    },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.headlineList.length
    },
    changeLang(data) {
      this.applicationLocale = data
      this.getMatch()
    },
    getConfig(data) {
      this.config = data
    },
    article(id) {
      this.$router.push({ path: '/pages/news/article', query: { id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    getAd() {
      api.getData('index/bannerList', { type: -1 })
        .then((res) => {
          storage.setItem('ad', res.data.data)
          this.adList = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    nav(url) {
      window.location.href = url
    },
    popup(val) {
      const currentTime = Date.now()
      const expireTime = currentTime + 3600 * 1000
      if (val === 'open') {
        const res = storage.getItem('popupAD')
        if (res && res.expireTime > Date.now()) {
          this.popupAD = false
        } else {
          this.popupAD = true
        }
        if (this.popupAD) {
          this.dialogVisible = true
        }
      }
      if (val === 'close') {
        storage.setItem('popupAD', {
          value: 'true',
          expireTime: expireTime
        })
        this.dialogVisible = false
      }
    }
  }
}
</script>

<style>
@import '../../public/static/css/index.css';

.carousel-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-item .text {
  position: absolute;

  z-index: 10;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 40px;
}

.carousel-item .move {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  color: #fff;
  font-size: 60px;
}

.popup-dialog {
  background: rgba(0, 0, 0, 0.8) !important;
}

.popup-dialog .el-dialog {
  background: transparent !important;
  box-shadow: none !important;
}
.el-dialog{
  margin: 0 auto !important;
  height: 100% !important;
}
</style>
